import React from "react";
import AnimatedRoutes from "./AnimatedRoutes";
import Navbar from "./Navbar";
import Footer from "./Footer";

function App() {
	return (
		<div className="App min-h-screen flex flex-col">
			<Navbar />
			<div className="flex-grow">
				<AnimatedRoutes />
			</div>
			<Footer />
		</div>
	);
}

export default App;
